import { apiBaseUrl, apiRequest } from "@/lib/api-client";

import type { Campaign, CampaignOverrides } from "./types";

export function createCampaign(input: {
  name: string;
  whop_url: string;
  content_url?: string | null;
  instructions?: string | null;
}) {
  return apiRequest<Campaign>("/campaigns", {
    method: "POST",
    body: JSON.stringify(input)
  });
}

export function listCampaigns() {
  return apiRequest<Campaign[]>("/campaigns");
}

export function getCampaign(campaignId: string) {
  return apiRequest<Campaign>(`/campaigns/${campaignId}`);
}

export function updateCampaign(
  campaignId: string,
  input: { name: string; whop_url: string; instructions?: string | null; content_url?: string | null } & Partial<CampaignOverrides>
) {
  return apiRequest<Campaign>(`/campaigns/${campaignId}`, {
    method: "PATCH",
    body: JSON.stringify(input)
  });
}

export function addCampaignSource(campaignId: string, contentUrl: string) {
  return apiRequest<Campaign>(`/campaigns/${campaignId}/sources`, {
    method: "POST",
    body: JSON.stringify({ content_url: contentUrl })
  });
}

async function uploadCampaignBrandingAsset(endpoint: string, file: File, fallbackMessage: string): Promise<Campaign> {
  const form = new FormData();
  form.append("file", file);
  // Let the browser set the multipart boundary; do not send a JSON Content-Type here.
  const response = await fetch(`${apiBaseUrl}${endpoint}`, { method: "PUT", body: form });
  const body = await response.json();
  if (!response.ok) {
    throw new Error(body && typeof body.detail === "string" ? body.detail : fallbackMessage);
  }
  return body as Campaign;
}

export function uploadCampaignLogo(campaignId: string, file: File) {
  return uploadCampaignBrandingAsset(`/campaigns/${campaignId}/logo`, file, "Logo upload failed");
}

export function deleteCampaignLogo(campaignId: string) {
  return apiRequest<Campaign>(`/campaigns/${campaignId}/logo`, { method: "DELETE" });
}

export function uploadCampaignIntroClip(campaignId: string, file: File) {
  return uploadCampaignBrandingAsset(`/campaigns/${campaignId}/intro-clip`, file, "Intro clip upload failed");
}

export function deleteCampaignIntroClip(campaignId: string) {
  return apiRequest<Campaign>(`/campaigns/${campaignId}/intro-clip`, { method: "DELETE" });
}

export function uploadCampaignOutroClip(campaignId: string, file: File) {
  return uploadCampaignBrandingAsset(`/campaigns/${campaignId}/outro-clip`, file, "Outro clip upload failed");
}

export function deleteCampaignOutroClip(campaignId: string) {
  return apiRequest<Campaign>(`/campaigns/${campaignId}/outro-clip`, { method: "DELETE" });
}
